import React from "react";

const HeroBanner = () => {
  return (
    <div className="heroBannerText">
      <span className="bannerTextTitle">
        Excellence Delivered Across The West
      </span>

      <span className="bannerTextSubTitle">
        Our mission is to provide cost-effective, professional, and efficient
        truckload services
      </span>
      <span className="bannerTextSubTitle">
        to all our customers. We build relationships on the promise of
        Excellence.
      </span>
      <div className="bannerCTA">
        <span className="navBannerDriveUs">Drive with us</span>
      </div>
    </div>
  );
};

export default HeroBanner;
